import React from 'react';
import './check-result-banner.css';

const CheckResultBanner = ({
  text,
  content,
  tone = 'success',
  onClose,
  autoHideMs = 10000,
  busy = false,
  progress,
}) => {
  React.useEffect(() => {
    if ((!text && content == null) || typeof onClose !== 'function' || busy) {
      return undefined;
    }
    if (!autoHideMs || autoHideMs <= 0) {
      return undefined;
    }

    const timerId = window.setTimeout(() => {
      onClose();
    }, autoHideMs);

    return () => {
      window.clearTimeout(timerId);
    };
  }, [text, content, onClose, autoHideMs, busy]);

  if (!text && content == null) return null;

  const showProgressBar = typeof progress === 'number' && !Number.isNaN(progress) && progress >= 0;

  return (
    <div className={`crb crb--${tone}`}>
      <div className="crb__col">
        <div className="crb__row">
          <span className="crb__text">{content != null ? content : text}</span>
          {busy ? (
            <span className="crb__spinner" aria-label="Выполняется" role="status" />
          ) : null}
        </div>
        {showProgressBar ? (
          <div className="crb__progress-track" aria-hidden>
            <div
              className="crb__progress-fill"
              style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
            />
          </div>
        ) : null}
      </div>
      {!busy ? (
        <button
          type="button"
          className="crb__close"
          onClick={onClose}
          aria-label="Закрыть уведомление"
          tabIndex={0}
        >
          ×
        </button>
      ) : (
        <span className="crb__close-placeholder" aria-hidden />
      )}
    </div>
  );
};

export default CheckResultBanner;
